import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import React, { forwardRef, useEffect } from "react";

import Logo from 'static/img/logo.png';

gsap.registerPlugin(ScrollTrigger);

const Partners = (props, ref) => {
	let scrollTl = null;

	useEffect(() => {
		scrollTl = gsap.timeline({
			scrollTrigger: {
				trigger: ref.current,
				invalidateOnRefresh: true,
				start: () => `top bottom-=200px`,
				markers: false,
				scrub: false, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
			},
		});

		scrollTl.fromTo(ref.current, { autoAlpha: 0 }, { autoAlpha: 1, duration: 1, ease: "Power2.inOut" }, 0.16);
	});

	return (
		<div className="about-partners" ref={ref}>
			<p className="about-partners__subtitle">Partners</p>
			<div className="about-partners__logo">
				<img src={Logo} alt="Logo Triptk" />
			</div>
		</div>
	);
};

export default forwardRef(Partners);
